import React from "react";
import { useFormContext } from "react-hook-form"; 
import { MedicalFields } from "../../../../../enums/MedicalReportEnums";
import { RichTextEditor } from "../../../../../components";

const MedicalRichTextEditor: React.FC<{
  field: any;
  disabled?: boolean;
  EditorClass?: string;
  labelClass?: string;
}> = ({ field = {}, EditorClass, labelClass, disabled }) => {
  const { setValue, watch } = useFormContext();

  const name = field?.Key ?? `Attributes.${String(field?.Id)}`;
  const hasWarning = field?.InverseParentStepFields?.some(
    (field: { Type?: number }) => field?.Type === MedicalFields.Warning,
  );

  const currentValue = watch(name) || "";

  const isEmptyHtml = (html: string): boolean => {
    if (!html || html.trim() === "") return true;

    const textOnly = html
      .replace(/<[^>]*>/g, "") 
      .replace(/&nbsp;/g, " ") 
      .replace(/\s+/g, "") 
      .trim();

    return textOnly === "";
  };

  const sanitizeHtmlContent = (html: string): string | null => {
    if (isEmptyHtml(html)) {
      return null; 
    }
    return html;
  };

  return (
    <>
      <RichTextEditor
        label={field?.Name}
        initialContent={currentValue}
        onChange={(value) => {
          const sanitizedValue = sanitizeHtmlContent(value);
          setValue(name, sanitizedValue || null); 
        }}
        EditorClass={EditorClass}
        labelClass={labelClass}
        disabled={disabled}
        message={hasWarning ? field?.InverseParentStepFields?.[0]?.Name : ""}
      />
    </>
  );
};

export default MedicalRichTextEditor;
